import * as React from 'react'
import {Util, ArrUtil} from 'yougile-util'
import {ReportDataField, ReportDataFieldLocalized} from 'yougile-model'
import {Lang} from 'yougile-lang'
import {DivWithHint} from '../../common/hint/hint'

interface Props {
  chosen: string[]
  allFields: ReportDataField[]
  update(chosen: string[]): void
}

// eslint-disable-next-line max-lines-per-function
export const StatsReportsColumns = (props: Props) => {
  const {chosen, allFields, update: upd} = props
  const update = (c: string[]) => upd(ArrUtil.unique(c, k => k))

  const fieldsIx: Map<string, ReportDataFieldLocalized> = new Map()
  allFields.forEach(f => fieldsIx.set(f(Lang.msg).key, f(Lang.msg)))
  const bem = Util.bemFrom('stats-reports-columns')
  const chosenFields = chosen.map(key => fieldsIx.get(key)).filter(f => !!f)
  const chosenIx = new Set(chosen)
  const remainedFields = allFields
    .map(f => f(Lang.msg))
    .filter(f => !chosenIx.has(f.key))

  const [activeKey, setActiveKey] = React.useState(
    remainedFields?.[0]?.key ?? ''
  )

  const activeIsCurrent = chosenIx.has(activeKey)
  const activeIsRemained = activeKey && !activeIsCurrent

  const field = (f: ReportDataFieldLocalized) => {
    const click = () => setActiveKey(f.key)
    return (
      <div
        key={f.key}
        className={bem('item', {active: f.key === activeKey})}
        onClick={click}
      >
        {f.getName()}
      </div>
    )
  }

  const add = () => {
    if (!activeKey || !activeIsRemained) {
      return
    }
    update([activeKey, ...chosen])
  }
  const remove = () => {
    if (!activeKey || !activeIsCurrent) {
      return
    }
    const ix = chosen.indexOf(activeKey)
    if (ix > -1) {
      update([...chosen.slice(0, ix), ...chosen.slice(ix + 1)])
    }
  }
  const up = () => {
    if (!activeKey || !activeIsCurrent) {
      return
    }
    const ix = chosen.indexOf(activeKey)
    if (ix > 0) {
      update([
        ...chosen.slice(0, ix - 1),
        chosen[ix],
        chosen[ix - 1],
        ...chosen.slice(ix + 1)
      ])
    }
  }
  const down = () => {
    if (!activeKey || !activeIsCurrent) {
      return
    }
    const ix = chosen.indexOf(activeKey)
    if (ix + 1 < chosen.length) {
      update([
        ...chosen.slice(0, ix),
        chosen[ix + 1],
        chosen[ix],
        ...chosen.slice(ix + 2)
      ])
    }
  }

  return (
    <div className={bem()}>
      <div className={bem('side')}>
        <div className={bem('title')}>{Lang.msg.report.tableAvailable}</div>
        <div className={bem('list')}>{remainedFields.map(f => field(f))}</div>
      </div>
      <div className={bem('actions')}>
        <DivWithHint
          className={bem('btn', {right: true, disabled: !activeIsRemained})}
          content={Lang.msg.report.tableAdd}
          onClick={add}
        />
        <DivWithHint
          className={bem('btn', {left: true, disabled: !activeIsCurrent})}
          content={Lang.msg.report.tableRemove}
          onClick={remove}
        />
      </div>
      <div className={bem('side')}>
        <div className={bem('title')}>{Lang.msg.report.tableCurrent}</div>
        <div className={bem('list')}>{chosenFields.map(f => field(f))}</div>
      </div>
      <div className={bem('actions')}>
        <DivWithHint
          className={bem('btn', {up: true, disabled: !activeIsCurrent})}
          content={Lang.msg.report.tableUp}
          onClick={up}
        />
        <DivWithHint
          className={bem('btn', {down: true, disabled: !activeIsCurrent})}
          content={Lang.msg.report.tableDown}
          onClick={down}
        />
      </div>
    </div>
  )
}
